import React, { useRef, useState } from "react";
import "./MediaSection.css";
import { Link } from "react-router-dom";

const MediaSection = () => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [showText, setShowText] = useState(true);

    const handlePlayPause = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
            } else {
                videoRef.current.play()
                    .then(() => {
                        setIsPlaying(true);
                        setShowText(false);
                    })
                    .catch(e => console.error("Error al reproducir:", e));
            }
            setIsPlaying(!isPlaying);
        }
    };

    const handleStop = () => {
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
            setIsPlaying(false);
            setShowText(true);
        }
    };

    return (
        <section className="white-section">
            <div className="compromiso-container">
                <div className="multimedia-btn">
                    multimedia CNgroup
                </div>
                <div className={`compromiso-hero ${isPlaying ? 'playing' : ''}`}>
                    <video
                        ref={videoRef}
                        className="video-background"
                        poster="/media.png"  
                        loop
                        muted
                        onEnded={() => {
                            setIsPlaying(false);
                            setShowText(true);
                        }}
                    >
                        <source src="/media1.mp4" type="video/mp4" />
                        Tu navegador no soporta videos HTML5.
                    </video>
                    
                    <div className="compromiso-texto">
                        {showText && (
                            <>
                                <h2 className="compromiso-titulo">Descubre nuestro compromiso con soluciones de energía completamente limpia</h2>
                                <p className="compromiso-descripcion">
                                    CNgroup está comprometida con el aprovechamiento de energías renovables a través del diseño,
                                    construcción y mantenimiento de instalaciones solares para empresas y hogares sostenibles.
                                </p>
                            </>
                        )}
                        
                        <div className="compromiso-botones">
                            <button className="compromiso-boton" onClick={handlePlayPause}>
                                <span className="icono-reproducir">
                                    {isPlaying ? '❚❚' : '▶'}
                                </span>
                                {isPlaying ? 'Pausar' : 'Reproducir'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MediaSection;